import { IconName } from './Icon';
import * as Icons from './IconList';

export const allIconNames = Object.keys(Icons) as IconName[];
